export type EditKeysType = 'NAME' | 'ID_FINAL_PRODUCT' | 'PRODUCTS';

export const EDIT_KEYS = ['NAME', 'ID_FINAL_PRODUCT', 'PRODUCTS'];

export const STORAGE_KEY = 'billOfMaterialEditData';
